(function () {
    'use strict';

    var fmgApp = angular.module('common-services');
    fmgApp.factory('commonLogService', function (appProduct, app_env, $http, $q, $location) {
        var svc = {}
        svc.buildStubLogPayload = function(eventName, isError){
          return  {
              source: 'ps-client',
              application: appProduct.name,
              eventName: eventName,
              level: isError ? 'error' : 'info',
              env: app_env.name,
              appVersion: app_env.version,
              eventData: {}
            }
        }
        svc.sendEvent = function(payload){
            if(app_env.loggingEnabled === true){
              return $http.post(app_env.baseUrl + 'LOG/pslogs/event', payload);
            }else{
              return $q(function(resolve, reject) {
                  resolve();
              });
            }
        }
        svc.decorateApiPromise = function(apiPromise){
          return apiPromise; //TODO - The below code will need uncommenting once the Docker services have been fixed.

          // return apiPromise.then(function(res){
          //   return svc.sendApiResponseEvent(res)
          // })
          // .catch(function(err){
          //   svc.sendApiResponseEvent(err)
          //   throw err;
          // })
        }
        svc.decorateApiFunction = function(func){
          return svc.decorateApiPromise(func())
        }
        svc.sendApiResponseEvent = function(response){

          try {
            var isError = !(response.status >= 200 && response.status < 300);
            var api = response.config.url.replace(app_env.baseUrl, '')
            var service = api.substring(0,api.indexOf('/'))
            var resultCode = response.status
            var responseTime = -1
            if(response.config.requestTimestamp  && response.config.responseTimestamp){
              var time = response.config.responseTimestamp - response.config.requestTimestamp;
              console.log('Time taken ' + (time / 1000) + ' seconds.');
              responseTime = time
            }

            var payload = svc.buildStubLogPayload('api-invoke', isError)
            payload.eventData.service = service,
            payload.eventData.api = api,
            payload.eventData.host =  $location.host(),
            payload.eventData.resultCode = resultCode,
            payload.eventData.responseTime = responseTime

            svc.sendEvent(payload);
            return response;

          } catch(err) {
            console.error('Logging Error', err)
            return $q(function(resolve, reject) {
                resolve(response);
            });
          }

        }
        return svc;
    });
})(window.angular);
